/** Actionable runtime errors remain visible in production; telemetry does not. */
export class GameplayStatus {
  readonly element: HTMLDivElement;
  private readonly message: HTMLParagraphElement;
  private readonly resume: HTMLButtonElement;

  constructor(onResume: () => void, parent = document.body) {
    this.element = document.createElement('div');
    this.element.className = 'mandalizm-gameplay-status';
    this.element.hidden = true;
    this.element.style.cssText = 'position:fixed;z-index:80;left:50%;top:18px;transform:translateX(-50%);' +
      'box-sizing:border-box;width:min(440px,calc(100vw - 24px));padding:12px 16px;' +
      'background:#00131e;border:1px solid #68d9d1;border-radius:8px;color:#d8fff5;' +
      'font:12px/1.5 ui-monospace,monospace;text-align:center;';
    this.element.setAttribute('role', 'status');
    this.message = document.createElement('p');
    this.message.style.margin = '0 0 8px';
    this.resume = document.createElement('button');
    this.resume.type = 'button';
    this.resume.textContent = 'RESUME AUDIO';
    this.resume.style.cssText = 'padding:12px 18px;color:#d8fff5;background:#08444e;border:1px solid #68d9d1;border-radius:5px;';
    this.resume.addEventListener('click', onResume);
    this.element.append(this.message, this.resume);
    parent.append(this.element);
  }

  show(message: string, canResume = true): void {
    this.message.textContent = message;
    this.resume.hidden = !canResume;
    this.element.hidden = false;
  }

  hide(): void { this.element.hidden = true; }
  dispose(): void { this.element.remove(); }
}
